import React from 'react'
import EventList from './eventList';
import { Banner } from '../../components';
import { Calendar } from '@phosphor-icons/react';

const PastEvent = ({ events,handleView, handleEdit, handleDelete, placeholderProps }) => {
  return (
    <div>
      {events?.length > 0 ? (
        <EventList
          status="past"
          events={events}
          handleView={handleView}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          allowViewOnClick={true}
        />
      ): (
        <Banner
          icon={<Calendar size={32}/>}
          title="You have no past events yet!"
          content="Let’s create your event."
          {...placeholderProps}
        />)}

    </div>
  )
}

export default PastEvent;